// extracted by mini-css-extract-plugin
export default {"container":"flexComponentMobile_container__23MTZ","leftTitle":"flexComponentMobile_leftTitle__S6RDP","rightNumber":"flexComponentMobile_rightNumber__TF0k1"};